module.exports = __webpack_public_path__ + "img/walkthrough_2.ef92506a.png";